import React from "react";
import ChrInfoPopover from "../../../Form/Basic/ChrInfoPopover";
import ChrLink from "../../../Utils/ChrLink";
import { renderToString } from "react-dom/server";
import i18n from "../../../../../utils/ChrI18n";

const ChrAlert = (props) => {
  const { id, met, count, description, className, renderedAsString = false, additionalIconClass = "", editAlertPath = null, allowManage = false } = props;
  if (!met) return;
  const clickEventStopper = (event) => {
    event.preventDefault();
    event.stopPropagation();
  }

  const alertConditionClass = `cjs_alert_${id}_condition_popup`;
  jQuery(document).on('click', '.' + alertConditionClass, (_event) => {
    editAlertPath && ManagementReport.renderPopup(editAlertPath);
  })

  const alertTooltip = (
    <div className="d-flex flex-column">
      <div>{`${String(count)} - ${String(description)}`}</div>
      { allowManage && <><br /><div className={`${alertConditionClass} text-info cursor-pointer`}>({ i18n.t("management_report_v2.alerts.view_conditions") })</div></> }
    </div>
  );

  return(
    <span className={ `${className} cursor-default` } onClick={ clickEventStopper }>
      <ChrInfoPopover
        html
        delay={500}
        boundary="body"
        renderedAsString={renderedAsString}
        content={renderToString(alertTooltip)}
        placement="auto"
        useTemplate
        templateOptions={{ wrapperOptions: { className: "chr-off-canvas-tooltip" }, bodyOptions: { className: "text-default-important" }}}
        iconClass="fa-bell"
        additionalIconClass={`${additionalIconClass} text-danger`}
        trigger="click hover"
      />
    </span>
  )
};

export default ChrAlert;